enum ChatGPTMessageRole {
  System = 1,
  Assistant = 2,
  User = 3,
  Function = 4,
}

enum EmbeddingSourceType {
  Article = 'Article',
  DynamicParamOption = 'DynamicParamOption',
}

// These represent directories in the knowledge git repo
// Topic's docs are saved under their respective directory
enum KnowledgeRagTopic {
  CampaignSetupAgent = 'campaign-setup-agent',
  AdBuilderAgent = 'ad-builder-agent',
  CampaignAnalyticsAgent = 'campaign-analytics-agent',
}

export {ChatGPTMessageRole, EmbeddingSourceType, KnowledgeRagTopic};
